import otmService from '@/services/otmService';

export default {
  /**
   * Closes "add to home screen" modal for apple
   */
  closeAddToHomeScreenModalForApple: async ({ commit }) => {
    localStorage.setItem('addToHomeIosPromptLastDate', Date.now())
    commit('setShowAddToHomeScreenModalForApple', false)
  },

  updateCurrentStep: async ({ commit }, method) => {
    commit('updateCurrentStep', method)
  },

  updateCompetitorByDomain({ commit }, method) {
    commit('updateCompetitorByDomain', method)
  },

  appendCompetitorError({ commit }, method) {
    commit('appendCompetitorError', method)
  },

  updateURL({ commit }, method) {
    commit('updateURL', method)
  },

  updateCompetitors: async ({ commit }, method) => {
    commit('updateCompetitors', method)
  },

  updateCompetitor: async ({ commit }, method) => {
    commit('updateCompetitor', method)
  },

  updateErrorMessage: async ({ commit }, method) => {
    commit('updateErrorMessage', method)
  },

  setClientIp: async ({ commit }) => {
    const response = await otmService.clientIp();
    
    const { ip } = response.data
    
    commit('updateClientIp', ip)
  },
  
}
